"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdSignSession = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const AccountService_1 = require("../AccountService");
const AccountSession_1 = require("./AccountSession");
class ThirdSignSession extends AccountSession_1.AccountSession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.third_login);
    }
    start(params) {
        this.subscription = AccountService_1.AccountService.verifyThirdAccount({ token: params.token, type: params.type })
            .pipe((0, operators_1.mergeMap)((thirdAccountData) => {
            if (thirdAccountData.has_bound) {
                return this.params.buAccount.thirdAuth({
                    token: thirdAccountData.biz_token,
                    lang: this.params.lang,
                    host: this.params.host,
                }, this.sessionHandler);
            }
            else if (thirdAccountData.user_exist) {
                return this.shouldThirdBind(thirdAccountData).pipe((0, operators_1.mergeMap)(() => {
                    return this.params.buAccount.thirdBind({
                        token: thirdAccountData.biz_token,
                        lang: this.params.lang,
                        host: this.params.host,
                    }, this.sessionHandler);
                }));
            }
            else {
                return this.getReferral(thirdAccountData).pipe((0, operators_1.mergeMap)((referral) => {
                    return this.params.buAccount.thirdRegister({
                        token: thirdAccountData.biz_token,
                        lang: this.params.lang,
                        host: this.params.host,
                        referral,
                    }, this.sessionHandler);
                }));
            }
        }))
            .subscribe(this.params.onSuccess, this.params.onError);
    }
    getReferral(thirdAccountData) {
        return new rxjs_1.Observable((subscriber) => {
            if (this.params.requestReferral) {
                this.params.requestReferral({
                    thirdAccountData,
                    callback: (referral) => {
                        subscriber.next(referral);
                        subscriber.complete();
                    },
                });
            }
            else {
                subscriber.next(undefined);
                subscriber.complete();
            }
        });
    }
    shouldThirdBind(thirdAccountData) {
        return new rxjs_1.Observable((subscriber) => {
            if (this.params.requestThirdBind) {
                this.params.requestThirdBind({
                    thirdAccountData,
                    callback: (password) => {
                        this.params.requestPassword = (callback) => callback(password);
                        subscriber.next();
                        subscriber.complete();
                    },
                });
            }
            else {
                subscriber.next(undefined);
                subscriber.complete();
            }
        });
    }
}
exports.ThirdSignSession = ThirdSignSession;
